"use strict";
/* eslint-disable @typescript-eslint/no-explicit-any */
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const AbstractCache_1 = __importDefault(require("./AbstractCache"));
const Observable_1 = __importDefault(require("./Observable"));
const exception_1 = require("@almservices-cl/exception");
class FailingInMemoryCache extends AbstractCache_1.default {
    constructor(failingGetRequest, failingSetRequest) {
        super();
        this.values = new Map();
        this.failing = false;
        this.startFailing = () => {
            this.failing = true;
        };
        this.setValue = (key, 
        // type-coverage:ignore-next-line
        value) => {
            const o = new Observable_1.default();
            if (this.failing && key === this.failingSetRequest) {
                o.setError(new exception_1.RuntimeException("Failed to set!"));
            }
            else {
                // type-coverage:ignore-next-line
                this.values.set(key, value);
                o.setValue(undefined);
            }
            return o;
        };
        this.getValue = (key) => {
            const o = new Observable_1.default();
            if (this.failing && key === this.failingGetRequest) {
                o.setError(new exception_1.RuntimeException("Failed to get!"));
            }
            else {
                // type-coverage:ignore-next-line
                const value = this.values.get(key);
                o.setValue(
                // type-coverage:ignore-next-line
                value === undefined ? null : JSON.parse(JSON.stringify(value))); // drop references
            }
            return o;
        };
        if (failingGetRequest) {
            this.failingGetRequest = failingGetRequest;
        }
        if (failingSetRequest) {
            this.failingSetRequest = failingSetRequest;
        }
    }
    clear() {
        return Promise.reject(new exception_1.RuntimeException("ups"));
    }
}
exports.default = FailingInMemoryCache;
//# sourceMappingURL=FailingInMemoryCache.js.map